import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// MOVE THESE CONSTANTS TO A COMMON LOCATION
import { columnWidths, EMPTY_USER } from './UserList.constants';
import Input from '../Input';
import TextButton from '../TextButton';
import { ListBodyRow, ListBodyRowContent, DataColumn } from '../List';
import * as regex from '../../constants/regex';

const StyledRow = styled(ListBodyRow)`
  margin-bottom: 8px;
`;

const RowContent = styled(ListBodyRowContent)`
  margin-left: 0;
  margin-right: 0;
`;
const inputMarginOffset = '8px';
const StyledInput = styled(Input)`
  & input {
    margin: 4px;
    max-width: calc(100% - ${inputMarginOffset});
  }
`;

const SuperUserForm = ({
  initialValue = EMPTY_USER,
  isSaving,
  onCancel,
  onSave,
}) => {
  const [isFormValid, setIsFormValid] = useState(false);
  const [user, setUser] = useState(initialValue);

  const setUserField = (fieldName) => (event) =>
    setUser({
      ...user,
      [fieldName]: event.target.value,
    });

  useEffect(() => {
    setIsFormValid(
      [!!user.displayName, regex.email.test(user.email)].every(Boolean)
    );
  }, [user]);

  const handleSave = () => {
    if (!isFormValid) return;
    onSave(user);
  };

  const renderInput = (fieldName) => (
    <DataColumn
      width={`calc(${columnWidths[fieldName]} - ${inputMarginOffset})`}
    >
      <StyledInput
        inputProps={{
          onChange: setUserField(fieldName),
          value: user[fieldName],
        }}
      />
    </DataColumn>
  );

  return (
    <StyledRow>
      <RowContent>
        {renderInput('displayName')}
        {renderInput('email')}
        <DataColumn width={columnWidths.editButtons} justify="flex-start">
          <TextButton disabled={isSaving} onClick={onCancel}>
            Cancel
          </TextButton>
          &nbsp;|&nbsp;
          <TextButton disabled={!isFormValid || isSaving} onClick={handleSave}>
            Save
          </TextButton>
        </DataColumn>
        <DataColumn width={columnWidths.passwordReset} />
      </RowContent>
    </StyledRow>
  );
};

SuperUserForm.propTypes = {
  initialValue: PropTypes.object,
  isSaving: PropTypes.bool,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
};

export default SuperUserForm;
